export default __webpack_public_path__ + "static/ai-agent-workflow-optimization-fc8d8b8385657b1b929306ed837c9612.jpg";